import React, { useEffect } from "react";
import { useState } from "react";
import { NewTraining, newTrainings } from "../../../../const/newTraining";
import { inscribe } from "./Inscribe";
import { title } from "process";
import ContactBar from "./ContactBar";

const PackEnterprise = () => {

    const [ trainings, setTrainings ] = useState<NewTraining[]>([])
    
    // const [ activeId, setActiveId ] = useState<number | null>(null)
    const [ activeIds, setActiveIds ] = useState<number[]>([])
    
    // const toggleActive = (id: number) => {
    //     setActiveId(activeId === id ? null : id)
    // }
    
    const toggleActive = (id: number) => {
        if (activeIds.includes(id)) {
            setActiveIds(activeIds.filter(activeId => activeId !== id))
        } else {
            setActiveIds([...activeIds, id])
        }
    }

    useEffect(() => {
        setTrainings(newTrainings)
    }, [])

    const handleInscribe = (title: string) => {
        inscribe(title);
    }

    return (
        <>
            <div id="tab-packs" className="section">
                <div className="section-title">Packs formation entreprise</div>
                <div className="section-sub">Solutions globales pour accélérer la transformation digitale de vos équipes</div>

                {trainings.length === 0 && (
                    <div style={{ textAlign: "center", padding: "50px 0", color: "#666" }}>
                        <i className="fa fa-spinner fa-spin" style={{ fontSize: "24px" }}></i>
                        <div style={{ marginTop: "10px" }}>Chargement des formations...</div>
                    </div>
                 )}
                {trainings.length > 0 && (
                    trainings.map((training) => (
                        training.type === "packEnterprise" && (
                            <div className="pack-card" style={{ border: "1.5px solid #1D9E75" }}>
                                <div style={{ display: "inline-block", fontSize: "11px", padding: "3px 10px", borderRadius: "8px", background: "#E1F5EE", color: "#085041", fontWeight: "500", marginBottom: "10px" }}>Pack phare</div>
                                <div className="pack-title">{training.title}</div>
                                <div className="pack-desc">{training.description}</div>
                                <ul className="pack-items">
                                    {training.include.map((item) => (
                                        <li key={item}><div className="check-dot"><svg viewBox="0 0 10 10" width="10" height="10"><polyline points="2,5 4,7.5 8,2.5" fill="none" stroke="#1D9E75" stroke-width="1.5"/></svg></div>{item}</li>
                                    ))}
                                </ul>
                                <div className="pack-footer">
                                    <div>
                                        <div className="pack-price">À partir de {training.min_price} FCFA</div>
                                        <div className="pack-price-sub">selon effectif et programme</div>
                                    </div>
                                    <button className="enroll-btn" onClick={() => handleInscribe(training.title)}>
                                        Demander un programme
                                    </button>
                                </div>
                            </div>
                        ))
                    )
                )};
            </div>
            {/* <ContactBar /> */}
        </>
    )

}

export default PackEnterprise;